(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["auran-planning-guide"] && !Shopify.designMode) return;
  try {
    
  function openAuranRoomCollection() {
    if (document.documentElement.classList.contains('shopify-design-mode')) return;
    const link = Array.from(document.querySelectorAll('[data-auran-room-anchor]')).find(item => item.dataset.auranRoomAnchor === window.location.hash);
    if (!link) return;
    const target = new URL(link.href);
    const preview = new URLSearchParams(window.location.search).get('preview_theme_id');
    if (preview) target.searchParams.set('preview_theme_id', preview);
    window.location.replace(target.href);
  }
  openAuranRoomCollection();
  window.addEventListener('hashchange', openAuranRoomCollection);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
